// @ts-nocheck
/* eslint-disable */
export const arrowNoBoxDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="#798693" d="M12.447 5.953H4.553c-.64 0-.96.774-.506 1.227L7.5 10.633a1.42 1.42 0 0 0 2.007 0L10.82 9.32l2.14-2.14a.721.721 0 0 0-.513-1.227"/></svg>`,
    name: 'arrow-no-box-down' as const
};